module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00051.1dd5893.png";